import React from "react";
import styled from "styled-components";
import tw from "twin.macro";
import { SectionHeading } from "components/misc/Headings";
import { useTranslation } from "react-i18next"; // For localization
import { SectionDescription } from "components/misc/Typography.js";
import {
  Container,
  ContentWithVerticalPadding,
} from "components/misc/Layouts.js";
import { ReactComponent as SvgDecoratorBlob1 } from "images/dot-pattern.svg";
import internationalImg from "images/business/international-market.svg";
import ChineseMarketContent from "./ChineseMarketContent";
import ChineseMarketMobileView from "./ChineseMarketMobileView";
const Heading = tw(SectionHeading)`text-ncc text-left`;
const Row = tw.div`flex flex-col lg:flex-row justify-between items-center lg:pt-16 max-w-screen-2xl mx-auto sm:px-8`;
const Col = tw.div`flex flex-col items-center lg:items-start justify-between lg:pt-16 max-w-screen-2xl mx-auto sm:px-8`;
const Column = tw.div``;
const TextColumn = tw(
  Column
)`mr-auto lg:mr-0 max-w-lg lg:max-w-xl xl:max-w-2xl`;
const Description = tw(SectionDescription)`mt-4 text-sm text-gray-700 max-w-lg`;
const ImageColumn = tw(Column)`ml-auto lg:mr-0 relative mt-16 lg:mt-0 lg:ml-32`;
const ImageContainer = tw.div`relative z-40 transform xl:-translate-x-24 xl:-translate-y-16`;
const Image = tw.img`max-w-full w-96 rounded-t sm:rounded relative z-20`;
const Offsetbackground = tw.div`absolute inset-0 bg-gray-300 rounded xl:-mb-8`;
const ImageDecoratorBlob = styled(SvgDecoratorBlob1)`
  ${tw`pointer-events-none z-10 absolute right-0 bottom-0 transform translate-x-10 translate-y-10 h-32 w-32 opacity-25 text-gray-900 fill-current`}
`;
export default ({
  isXs = false,
  imageSrc = internationalImg,
  imageDecoratorBlob = true,
}) => {
  if (isXs) return <ChineseMarketMobileView />;
  const { t } = useTranslation(); // Use localization
  return (
    <div id="chinese-market">
      <Container>
        <ContentWithVerticalPadding>
          <Row>
            <TextColumn>
              {/* <BgTitle borderHide={true} text={t("business.chineseMarketSupport.heading")} /> */}

              <Heading>{t("business.chineseMarketSupport.heading")}</Heading>
              <Description>
                {t("business.chineseMarketSupport.description")}
              </Description>
            </TextColumn>
            <ImageColumn>
              <ImageContainer>
                <Image src={imageSrc} />
                {imageDecoratorBlob && <ImageDecoratorBlob />}
              </ImageContainer>
              <Offsetbackground />
            </ImageColumn>
          </Row>
          <Col>
            <ChineseMarketContent />
          </Col>
        </ContentWithVerticalPadding>
      </Container>
    </div>
  );
};
